import { FC } from 'react';

type Props = {
	className?: string;
};

const Location_01_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.76663 17.9494L9.7708 17.9514C9.9151 18.0155 10.0802 18.0157 10.2245 17.9516L10.2273 17.9503C10.2442 17.9426 10.2858 17.9235 10.3106 17.9118C10.3635 17.887 10.4394 17.8505 10.5352 17.8027C10.7267 17.7069 10.9979 17.5653 11.3222 17.3791C11.9696 17.0074 12.8354 16.4546 13.7039 15.7308C15.4223 14.2988 17.2535 12.1101 17.2535 9.25566C17.2535 5.24847 14.0051 2 9.99785 2C5.99065 2 2.74219 5.24847 2.74219 9.25566C2.74219 12.1101 4.57342 14.2988 6.29178 15.7308C7.16035 16.4546 8.02608 17.0074 8.67345 17.3791C8.99783 17.5653 9.26901 17.7069 9.46048 17.8027C9.55388 17.8493 9.70985 17.9227 9.76663 17.9494ZM9.99785 6.27898C8.35387 6.27898 7.02117 7.61168 7.02117 9.25566C7.02117 10.8996 8.35387 12.2323 9.99785 12.2323C11.6418 12.2323 12.9745 10.8996 12.9745 9.25566C12.9745 7.61168 11.6418 6.27898 9.99785 6.27898Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default Location_01_IconSolid;
